import storage from "redux-persist/lib/storage";

export const posPersistConfig = {
  key: "posRoot",
  storage,
  whitelist: ["posData"], 
}; 